module.exports = __webpack_public_path__ + "img/GIS_Total_Reports.daa057c6.svg";